import ExcelJS from "exceljs";
import { saveAs } from 'file-saver';
import DrawExcel from "@/commonFuncion/DrawExcel";
import moment from "moment";

export async function exportToExcel(exportToExcelData, otherObject) {

    // Dữ liệu truyền vào từ component
    const titleFile = exportToExcelData.titleFile;
    const columnHeaders = exportToExcelData.columnHeaders;
    const companyInfo = exportToExcelData.companyInfo;
    const columnWidths = exportToExcelData.columnWidths;
    const dataList = exportToExcelData.dataList;
    const fileName = exportToExcelData.nameFile;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(fileName);

    await DrawExcel.drawColumnWidths(columnWidths, worksheet);

    await DrawExcel.drawCompanyInfo(companyInfo, worksheet);

    if (fileName.match('ThongKe')) {
        await DrawExcel.drawTitleRowNew(titleFile, worksheet);
        await DrawExcel.drawTableHeadersStatistics(columnHeaders, worksheet);
        await DrawExcel.drawTableStatistics(dataList, worksheet);
        if (otherObject && otherObject.length > 0) {
            await DrawExcel.drawTotalDataStatistics(otherObject, worksheet);
        }
    } else {
        await DrawExcel.drawTitleRow(titleFile, worksheet);
        worksheet.addRow([]);
        await DrawExcel.drawTableHeaders(columnHeaders, worksheet);
        await DrawExcel.drawTable(dataList, worksheet);
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const timeStamp = moment().format('YYYYMMDD_HHmmss');
    const finalFileName = `${fileName}_${timeStamp}.xlsx`;
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), finalFileName);

}

